import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import '../../css/Buttons.css';
import {config} from '../../constants';
import CircleSign from '../ui/CircleSign';
import {deleteKey} from '../../utils/exportMethods';
import ConfirmationModal from '../ui/ConfirmationModal';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';
const url = config.url.URL;

const dataSource = createStore({
  key: "geoElementId",
  loadUrl: `${url}/GeoElementMicroservice/countries`,
  insertUrl: `${url}/GeoElementMicroservice/countries`,
  updateUrl: `${url}/GeoElementMicroservice/countries`,
  deleteUrl: `${url}/GeoElementMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+'/admin' + (section != '' ? '/'+section : '')) ;
}

const exportCountriestoExcel = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, 'geoElementId');
    deleteKey(obj, 'level');
    deleteKey(obj, 'subZoneGeoElementId');
    deleteKey(obj, 'zoneGeoElementId');
  });

  const headers = [
    { header: 'Country/Region', key: 'name', autoFit: true },
    { header: 'Subzone', key: 'subZoneName', autoFit: true },
    { header: 'Zone', key: 'zoneName', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true }
  ];

  await exportToExcel(headers, apiData, 'country_region_extract', 'Country & Region Extract');
};

class Country extends React.Component {
  
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];

        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          Zones: [],
          SubZones: [],
          showCountryMenu: true,
          showZoneMenu: true,
          showSubZoneMenu: true,
          showModal: false,
          showEditModal:false,
          showConfirmationModal:false,
          oldCheckValue: false,
          validation: true,
          nameVal:true,
          subZoneVal:true,
          duplicatedValidation:true,
          selectedRowName:"",
        };

        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.confDiag = React.createRef();
      }

      
      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }


      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }

      // to refresh our datagrid table and close all modals
      useRefresh = () => {
        this.dataGrid.useRefresh();
        this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }
  
      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }
  
      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false});
      }
  
      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
      }


      openModal = () => {   
        this.setState({showModal:true, duplicatedValidation: true ,
          validation:true, nameVal:true, subZoneVal:true});
        }
    
  onExportToExcel = () => {
    apiClient.get(`${url}/GeoElementMicroservice/countries`)
      .then(response => {
        const data = response.data;
        if (data) {
          exportCountriestoExcel(data);
          toast.success('Country/Region Excel export file has been generated');
        }
      });
  }

 

  onCreateCountries = () => {
    this.setState({ duplicatedValidation: true })
    let name = this.refs.Name.value.trim();;
    let subzone = this.refs.optionSubZones.value;

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (subzone == "") {
      this.setState({ subZoneVal: false })
    } else {
      this.setState({ subZoneVal: true })
    }

    if (name != "" && subzone != "") {

      let CountryInfo = {
        Name: name,
        ParentGeoElementId: subzone,
        IsEnabled: true
      };
      apiClient.post(`${url}/GeoElementMicroservice/countries`, CountryInfo)
      .then(repsonse => {
          const data = repsonse.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Country/Region has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    } else {
      this.setState({ validation: false })
      return;
    }
  }

  onEditCountry = () => {
    let name = this.refs.Name_Edit.value.trim();
    let subzone = this.refs.EditoptionSubZones.value;
    this.setState({ duplicatedValidation: true })

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (subzone == "") {
      this.setState({ subzone: false })
    } else {
      this.setState({ subzone: true })
    }

    if (name != "" && subzone != "") {

      let CountryInfo = {
        geoElementId: this.state.selectedRowIndex,
        Name: name,
        ParentGeoElementId: subzone,
        IsEnabled: this.state.oldCheckValue
      };
      apiClient.put(`${url}/GeoElementMicroservice`, CountryInfo)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              if (this.state.oldCheckValue != this.refs.chk_Is_Enabled.checked) {
                this.confDiag.current.state.status = this.refs.chk_Is_Enabled.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                toast.success('Country/Region has been updated');
                this.useRefresh();
              }
            }
          }
        });
    } else {
      this.setState({ validation: false });
      return;
    }
  }

  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Country/Region has been enabled');
      }
      else {
        toast.success('Country/Region has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Country/Region has been enabled');
      }
      else {
        toast.success('Country/Region has been disabled');
      }
    }
  }

  compare( a, b ) {
    if ( a.name < b.name ){
      return -1;
    }
    if ( a.name > b.name ){
      return 1;
    }
    return 0;
  }

  openEditModal = (e) => {   
    const countryName = e.row.data.name.trim();
    this.setState({duplicatedValidation: true,showEditModal:true,  validation:true, nameVal:true, subZoneVal:true});     
    this.setState({selectedRowIndex: e.row.data.geoElementId, selectedRowName : countryName}); 
  
    const enabledSubZones = this.state.SubZones.filter(obj => {
      return obj.isEnabled === true;
    });
    this.setState({SubZones:enabledSubZones });
      if(
        enabledSubZones.find(x=>x.geoElementId == e.row.data.subZoneGeoElementId) == undefined){
          var l_SubZones = enabledSubZones;
          l_SubZones.push( {
            geoElementId:e.row.data.subZoneGeoElementId,
            name :e.row.data.subZoneName
          })
          l_SubZones.sort( this.compare );
          this.setState({SubZones:l_SubZones })
        }  
   
    this.refs.Name_Edit.value = e.row.data.name;
    this.refs.EditoptionSubZones.value = e.row.data.subZoneGeoElementId;
    this.refs.chk_Is_Enabled.checked = e.row.data.isEnabled;
    this.setState({oldCheckValue: e.row.data.isEnabled});
  }

  fetchSubZones() {
    let initialSubzones = [];
    apiClient.get(`${url}/GeoElementMicroservice/subzonesadmindropdown?isEnabled=true`)
      .then(response => {
        const data = response.data;
        initialSubzones = data;
        this.setState({
          SubZones: initialSubzones,
        });
      });
  }

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem('token'));
  this.setState({
    showCountryMenu: decoded.can_manage_country === "true",
    showZoneMenu: decoded.can_manage_zone === "true",
    showSubZoneMenu: decoded.can_manage_subzone === "true",
    can_export_to_excel: decoded.can_export_to_excel === "true"
  });
    this.fetchSubZones();
  }

  Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
  }

  Checkisdisabled = (e) =>{
  return !e.row.data.isEnabled ;
  }

  onDelete = (e) => {
    this.confDiag.current.state.key = e.row.data.geoElementId;  
    this.confDiag.current.state.status = e.row.data.isEnabled;
    this.confDiag.current.state.inEditMode = false;
    this.confDiag.current.handleOpenConfirmDialog();
  }

  render() {

  let l_SubZones = this.state.SubZones;
  let optionSubZones = l_SubZones.map((Subzone) =>
      <option value={Subzone.geoElementId}>{Subzone.name}</option>
  );

  const columns = [
    { dataField: "isEnabled", caption: "Status", width: "110" },
    { dataField: "name", caption: "Country/Region", width: "33%"},
    { dataField: "subZoneName", caption: "Subzone", width: "33%"},
    { dataField: "zoneName", caption: "Zone", width: "33%"},
    // Add other columns specific to Profiles component
  ];

  const buttonColumn = [
    {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
    {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
    {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
    // Additional buttons for Profiles component
  ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>            
           {'Geography > Country/Region Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button  className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Country/Region</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
          <div className="div-body-submenu">
          <div className={this.state.showZoneMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('zones')} >              
             <div class="div-submenu-label">
                    <label>Zones</label>
                </div> 
                            
            </div>
            <div className={this.state.showSubZoneMenu ? "div-submenu-link" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('subzones')} >              
             <div class="div-submenu-label">
                    <label>Subzones</label>
                </div> 
                            
            </div>
            <div className={this.state.showCountryMenu ? "div-submenu-link active" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('countries')} >              
             <div class="div-submenu-label">
                    <label>Country/Region</label>
                </div> 
                            
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">
          <CustomDataGrid
              dataSource={dataSource}
              keyExpr="countryId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>
      
      <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New Country/Region</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Country/Region already exists, your updates cannot be saved. Please go back to Country/Region Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Country/Region form is not allowed</p></Row>  } 
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="zone">
              <Form.Label className={`${this.state.subZoneVal ? "normal-title" : "validation-title"}`}>Subzone  <CircleSign/></Form.Label>   
              <Form.Control 
                className={`select-placeholder ${!this.state.subZoneVal && "validation-control"}`}
                ref="optionSubZones"  
                placeholder="SubZone" 
                as="select" 
                type="select" 
                required
                defaultValue=""
                >
              <option value="" hidden>Subzone</option>
                  {optionSubZones}                                
              </Form.Control>
              {!this.state.subZoneVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>     
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateCountries}>
            Create Country/Region
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit Country/Region</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body> 
        {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Country/Region already exists, your updates cannot be saved. Please go back to Country/Region Management list to edit the corresponding form.</p></Row>  } 
        {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Country/Region form is not allowed</p></Row>  }  
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="Name">
              <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
              <Form.Control type="text" ref="Name_Edit" placeholder="Name" className={`${!this.state.nameVal && "validation-control"}`}/>
              {!this.state.nameVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3 col-md-12" controlId="zone">
              <Form.Label className={`${this.state.subZoneVal ? "normal-title" : "validation-title"}`}>Subzone  <CircleSign/></Form.Label>   
               
              <Form.Control ref="EditoptionSubZones" placeholder="SubZone" as="select" type="select" className={`${!this.state.subZoneVal && "validation-control"}`}>
              <option value="" hidden>Subzone</option>
                  {optionSubZones}                                
              </Form.Control>
              {!this.state.subZoneVal && <p className="p-required">Required</p>}
            </Form.Group>
          </Row> 
          <Row>
            <Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" ref="chk_Is_Enabled" label="Is Enabled" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditCountry}>
            Update Country/Region
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>
      
      <ConfirmDialog ref={this.confDiag} microserviceName="GeoElementMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh}  title="Error" msg="You can't enable this country because it is linked to a disabled Subzone. Please modify the Subzone selected or go to Subzones administration to enable the current one."></ConfirmDialog>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
    onShowFilterRowChanged(e) {
      this.setState({
        showFilterRow: e.value
      });
      this.clearFilter();
    }

    onShowHeaderFilterChanged(e) {
      this.setState({
        showHeaderFilter: e.value
      });
      this.clearFilter();
    }

    onCurrentFilterChanged(e) {
      this.setState({
        currentFilter: e.value
      });
    }

    clearFilter() {
      this.dataGrid.clearFilter();
    }
}

export default Country;
